import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  refreshFrame() {
    this.element.reload();
  }
}
